import { Alert, Box } from '@mui/material'
import { useParams, useSearchParams } from 'react-router-dom'
import { Navigate } from '../lib/router'
import { AppShell, Crumb, HomeCrumb } from '../components/AppShell'
import { useRun } from '../api/hooks'
import { SkeletonScreen } from '../components/Skeleton'

/**
 * An old link to a run's results. A run's results are its region's page
 * now — the same map, table and report, plus the region around them — so
 * this only finds the region and goes there, keeping the view and filter.
 */
export function Results() {
  const { runId } = useParams<{ runId: string }>()
  const [params] = useSearchParams()
  const { data: run, isLoading, error } = useRun(runId)
  const crumbs = [<HomeCrumb key="a" />, <Crumb key="b" mono>{runId?.slice(0, 8)}</Crumb>]

  if (run) {
    const keep = new URLSearchParams()
    for (const key of ['view', 'check']) {
      const value = params.get(key)
      if (value) keep.set(key, value)
    }
    const q = keep.toString()
    return <Navigate to={`/regions/${run.region_id}${q ? `?${q}` : ''}`} replace />
  }

  return (
    <AppShell crumbs={crumbs} rail={false}>
      {isLoading ? <SkeletonScreen wide /> : (
        <Box sx={{ flex: 1, display: 'grid', placeItems: 'center', p: 8 }}>
          <Alert severity="warning">{(error as Error | null)?.message ?? 'No such run.'}</Alert>
        </Box>
      )}
    </AppShell>
  )
}
